import { render, staticRenderFns } from "./AddAtractionButton.vue?vue&type=template&id=61f79851&scoped=true"
import script from "./AddAtractionButton.vue?vue&type=script&lang=js"
export * from "./AddAtractionButton.vue?vue&type=script&lang=js"
import style0 from "./AddAtractionButton.vue?vue&type=style&index=0&id=61f79851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f79851",
  null
  
)

export default component.exports